import themeGet from '@styled-system/theme-get';
import styled from 'styled-components';

import theme from '../../themes/phoenix/theme';
import Pagination from '../Pagination';

export const SectionWrapper = styled.div`
  border-radius: 20px;
  background-color: ${theme.colors.greys[1]};
  display: flex;
  flex-direction: column;
  margin-top: 32px;
  
  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    overflow: hidden;
  }
`;

export const FeaturedBlogWrapper = styled.div`
  margin: 30px 32px;
  overflow: hidden;
`;

export const FeaturedBlogTitle = styled.div`
  color: ${theme.colors.black};
  /* PCI/Desktop/H2 */
  font-size: 48px;
  font-style: normal;
  font-weight: 600;
  line-height: 58px;
  margin-bottom: 16px;

  @media only screen and (max-width: ${themeGet('breakpoints.lg')}) {
    /* PCI/Mobile/B1 */
    font-size: 32px;
    line-height: 40px;
  }
`;

export const FeaturedBlogCategory = styled.div`
  color: ${theme.colors.red};

  font-family: ${themeGet('typography.mobile.heading1.fontFamily')};
  font-weight: ${themeGet('typography.mobile.body2.fontWeight')};
  font-size: ${themeGet('typography.mobile.body2.fontSize')};
  margin: 0 0 20px 0;

  @media only screen and (max-width: ${themeGet('breakpoints.lg')}) {
    /* PCI/Mobile/B1 */
    font-weight: ${themeGet('typography.mobile.body3.fontWeight')};
    font-size: ${themeGet('typography.mobile.body3.fontSize')};
  }
`;

export const FeaturedBlogSummary = styled.div`
  color: ${theme.colors.black};

  /* PCI/Desktop/B1 */
  font-size: 18px;
  font-style: normal;
  font-weight: 300;
  line-height: 28px;
  margin-bottom: 24px;

  @media only screen and (max-width: ${themeGet('breakpoints.lg')}) {
    /* PCI/Mobile/B1 */
    font-size: 16px;
    line-height: 24px;
  }
`;

export const ReadMoreBtn = styled.a`
  border-radius: 30px;
  background-color: ${theme.colors.black};
  padding: 8px 16px;
  color: ${theme.colors.white};
  font-size: 16px;
  font-style: normal;
  font-weight: 200;
  line-height: 34px;
`;

export const BlogGridWrapper = styled.div`
  margin-top: 32px;

  @media only screen and (max-width: ${themeGet('breakpoints.md')}) {
    padding: 0 20px;
  }
`;

export const StyledGrid = styled.div`
  margin-top: 20px;
  display: grid;
  gap: 20px;
  grid-template-columns: repeat(3, 1fr);

  @media only screen and (max-width: ${themeGet('breakpoints.md')}) {
    grid-template-columns: repeat(1, 1fr);
  }
`;

export const PostsTitle = styled.h2`
  /* PCI/Desktop/H3 */
  font-size: 36px;
  font-style: normal;
  font-weight: 600;
  line-height: 44px;
  margin: 30px 0 16px 0;
`;

export const PostsSubtitle = styled.div`
  align-items: center;
  justify-content: center;
  /* PCI/Desktop/B3 */
  font-size: 20px;
  font-style: normal;
  font-weight: 300;
  line-height: 24px;
  padding: 8px 16px 8px 0;
`;

export const BlogTitle = styled.h1`
  color: ${theme.colors.black};
  font-size: 66px;
  font-style: normal;
  font-weight: 600;
  line-height: 78px;

  @media only screen and (max-width: ${themeGet('breakpoints.lg')}) {
    font-size: 38px;
    line-height: 46px;
  }

  @media only screen and (max-width: ${themeGet('breakpoints.md')}) {
    font-weight: 500;
    padding: 0 20px;
  }
`;

export const WhiteBackground = styled.div`
  background-color: ${theme.colors.white};
  font-family: Noir Pro;
`;

export const MarginWrapper = styled.div`
  margin: 0 auto;
  max-width: 1280px;
  width: calc(100% - 60px);
  padding: 64px 80px;

  @media only screen and (max-width: ${themeGet('breakpoints.lg')}) {
    width: 100%;
    padding: 32px 40px;
  }

  @media only screen and (max-width: ${themeGet('breakpoints.md')}) {
    width: 100%;
    padding: 16px 0px;
  }
`;

export const MarginWrapperBlogPost = styled(MarginWrapper)`
  @media only screen and (max-width: ${themeGet('breakpoints.md')}) {
    padding: 0;
  }
`;

export const Container = styled.div`
  border-radius: 20px;
  background-color: ${theme.colors.greys[1]};
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: flex-start;
  max-height: 390px;
  overflow: hidden;
  position: relative;
  width: 100%;
`;

export const Blurb = styled.div`
  background: ${theme.colors.greys[1]};
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  padding: 1rem;
`;

export const BlogCardTitle = styled.a`
  color: ${themeGet(`colors.black`)};
  font-size: 18px;
  font-weight: 300;
  flex-grow: 1;
  line-height: 24px;
  padding-bottom: 8px;
  text-decoration: none;
`;

export const BlogCardCategory = styled.div`
  color: ${themeGet(`colors.red`)};
  font-size: 14px;
  font-weight: 400;
`;

export const BlogLink = styled.a`
  color: ${themeGet(`colors.black`)};
  flex-grow: 0;
  font-size: 16px;
  font-family: Noir Pro;
  font-style: normal;
  font-weight: 200;
  line-height: 24px;
  text-decoration-line: underline;
`;

export const PaginationWrapper = styled.div`
  display: flex;
  margin-top: 24px;
`;

export const Number = styled.div`
  color: ${themeGet('colors.white')};
  text-align: center;
  /* PCI/Desktop/B1 */
  font-size: 24px;
  font-style: normal;
  font-weight: 400;
  line-height: 28px;
  border-radius: 100px;
  background: ${themeGet('colors.red')};
  width: 44px;
  height: 44px;
  padding-top: 6px;
  margin-right: 16px;
  cursor: pointer;
`;

export const DotDotDot = styled.div`
  color: ${themeGet('colors.black')};
  text-align: center;
  /* PCI/Desktop/B3 */
  font-size: 16px;
  font-family: Noir Pro;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  margin-right: 16px;
  align-self: end;
`;

export const BlogGridPagination = styled(Pagination)`
  margin-top: 24px;
  align-self: center;
`;

export const CategoryFilter = styled.div`
  display: flex;
  padding: 8px 16px;
  justify-content: center;
  align-items: center;
  font-size: 20px;
  font-style: normal;
  line-height: 24px;
  user-select: none;
  color: ${(props) => props.selected ? themeGet('colors.red') : themeGet('colors.black')};
  font-weight: ${(props) => props.selected ? 400 : 300};
  cursor: pointer;
`;

export const BlogFilter = styled.div`
  border-bottom: 2px solid currentColor;
  padding-bottom: 5px;
`;

export const BlogFilterWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

export const FilterIcon = styled.img`
  width: 18px;
  height: 16px;
  margin-right: 8px;
`;

export const BlogSearch = styled.input``;

export const Desktop = styled.div`
  display: none;

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    display: flex;
  }
`;

export const Mobile = styled.div`
  display: flex;

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    display: none;
  }
`;

export const BlogFilterDropdown = styled.select`
  appearance: none;
  border: 1px solid #000;
  border-radius: 5px;
  font-weight: bold;
  padding: 10px;
  width: 100%;
`;
